import React, {Component, Fragment} from "react";
import {Button, Col, Input, Label, Nav, NavItem, NavLink, Row, TabContent, TabPane} from "reactstrap";
import {
  formsMultiUpdater,
  formsUpdater,
  getFormFieldValue,
  traversePropertiesArray,
  traversePropertiesString
} from "../../Applications/shared/shared";
import classnames from 'classnames';
import {EventClient} from "../../../util/eventClient";
import {getData, patchData} from "../../../api/doLogin";
import {MakeDialog} from "../../../components/Shared/MakeDialog";
import './taxintake.css';
import NotesTab from "../views/NotesTab";
import DocumentsTab from "../views/DocumentsTab";
import ReactToPrint from "react-to-print";
import {TaxIntakeStatusList} from "../../../constants/TaxIntakeConstants";

export default class TaxIntakeEditor extends Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      lmsId: null,
      intakeId: null,
      appttypes: [],
      dataLoaded: false,
      formData: {}, // Left off here. Make edit be ID and retrieve Entry data with appt Constants.
      noteData: {},
      sweepstakes: [],
      url: null,
      edit: [],
      notes: [],
      documents: [],
      showLMSPicker: false,
      activeTab: "1",
      hideButtons: false,
    };
    // console.log("Loaded fileeditor");
  }

  componentWillMount() {
    EventClient.on("TAX_INTAKE_ENTRY_EDIT", ({id, lms_id}) => this.setState({
      lmsId: lms_id,
      intakeId: id,
      open: true,
      dataLoaded: false,
      activeTab: "1"
    }, () => {
      this.getTaxIntakeEntry(lms_id, id);
    }), "TaxIntakeEditor");
    // EventClient.on(this.props.saveEvent, () => this.saveExternal(), this.props.eventName);
    // EventClient.on(this.props.deleteEvent, () => this.deleteExternal(), this.props.eventName);
    // setTimeout(() => {
    //   EventClient.emit("TAX_INTAKE_ENTRY_EDIT", {id: 1181, lms_id: 37131})
    // }, 1000);
  }

  componentWillUnmount() {
    EventClient.off("TAX_INTAKE_ENTRY_EDIT", () => {
    }, "TaxIntakeEditor");
    // EventClient.off(this.props.saveEvent, () => this.saveExternal(), this.props.eventName);
    // EventClient.off(this.props.deleteEvent, () => this.deleteExternal(), this.props.eventName);
  }

  saveExternal() {
    // console.log(this.state.formData);
    this.save((resp) => {
      if (this.props.onSave) {
        this.props.onSave(resp);
      }
    })
  }

  deleteExternal() {
    // deleteData(`briefcase/${this.props.folderId || 0}/${this.props.edit || 0}`, {}, this.props.token)
    //   .then((data) => {
    //     if (data.status === "Success") {
    //       EventClient.emit("BRIEFCASE_REFRESH", this.props.folderId || 0);
    //       EventClient.emit("NAVIGATE", `/briefcase/${this.props.folderId || 0}`);
    //     }
    //   }).catch((error) => {
    //   console.log(error);
    // });
  }

  saveInternval() {

  }

  downloadFile() {
    if (!this.props.edit || this.props.edit === 0) return;
    const self = this;
    // getData(`briefcase/${this.props.folderId || 0}/${this.props.edit || 0}/download`, {}, this.props.token)
    //   .then((data) => {
    //     if (data.status === "Success") {
    //       // console.log(data.data);
    //       if (data.data.url !== null) {
    //         window.open(data.data.url, "_blank");
    //       } else {
    //         toast.error("Could not download");
    //       }
    //     } else {
    //       toast.error("Could not download");
    //     }
    //   }).catch((error) => {
    //   console.log(error);
    //   toast.error("Could not download");
    // });
  }

  getTaxIntakeEntry(lmsId, intakeId) {
    // console.log(this.props.edit);
    if (!lmsId || lmsId === 0 || lmsId === "0") return;
    const self = this;
    getData(`intakes/${lmsId || 0}/${intakeId || 0}`, {}, this.props.token)
      .then((data) => {
        if (data.status === "Success") {
          // console.log(data.data);
          let responseStateData = {
            notes: data.data.notes,
            // formData: data.data.file,
            formData: data.data.intake,
            documents: data.data.documents,
            // url: data.data.url,
            dataLoaded: true
          };
          self.setState(responseStateData);
        }
      }).catch((error) => {
      console.log(error);
    });
  }

  closeMe() {
    this.setState({
      lmsId: null,
      intakeId: null,
      open: false,
      dataLoaded: false,
      notes: [],
      formData: {},
      documents: [],
      activeTab: "1",
    });
  }

  saveNote() {

  }

  updateStatus() {
    const self = this;
    self.setState({loading: true}, () => {

      patchData(`intakes/${this.state.lmsId || 0}/${this.state.intakeId || 0}/status/${getFormFieldValue(this.state.formData['status'])}`, {}, this.props.token)
        .then((data) => {
          // console.log(data);
          if (data.status === "Success") {
            self.setState({loading: false});
            EventClient.emit("TOAST_SUCCESS", "Status Saved Successfully");
            self.props.onUpdate && self.props.onUpdate(self.state.lmsId, self.state.intakeId);
          } else {
            self.setState({loading: false});
            EventClient.emit("TOAST_ERROR", "Status not saved. Try later");
          }
        })
        .catch(error => {
          self.setState({loading: false});
          EventClient.emit("TOAST_ERROR", "Status not saved. Try later");
          console.error(error);
        });
    });
  }

  save(cb) {
    const payload = {formData: this.state.formData || null};
    if (!payload.formData.filename.endsWith(`.${payload.formData.ext}`)) {
      payload.formData.filename = payload.formData.filename.concat(`.${payload.formData.ext}`);
    }
    //console.log(payload);
    // return cb(null);
    const self = this;
    // postData(`briefcase/${this.props.folderId || 0}/${this.props.edit || 0}/save`, payload, this.props.token)
    //   .then((data) => {
    //     // console.log(data);
    //     if (data.status === "Success") {
    //       cb({...self.state.formData});
    //     }
    //   })
    //   .catch(error => {
    //     console.error(error);
    //   });
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  render() {
    if (!this.state.open) return null;
    const containerStyle = {
      zIndex: 1999
    };

    return (
      <MakeDialog isOpen={this.state.open}
                  headerTag={"div"}
                  header={<div style={{display: "flex", justifyContent: "space-between"}}>
                    <h4>Intake Data</h4>
                    <span style={{display: "flex", fontSize: 11}}>
                      <span className={"form-group-condensed"}>
                            <Label for="status">Update Intake Status</Label>
                            <Input
                              type="select"
                              id="status"
                              value={getFormFieldValue(this.state.formData['status'])}
                              onChange={(evt) => formsUpdater(evt, this.state['formData'], this, () => this.updateStatus())}
                            >
                              {TaxIntakeStatusList.map((display, value) => {
                                return <option key={value} value={value}>{display}</option>
                              })}
                            </Input>
                      </span>
                      <ReactToPrint
                        trigger={() => {
                          // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                          // to the root node of the returned component as it will be overwritten.
                          return <Button color="secondary">Print Intake</Button>;
                        }}
                        content={() => this.intakeRef}
                      />

                          <Button color="secondary"
                                  onClick={() => this.closeMe()}>Close</Button>
                    </span>
                  </div>}
                  footer={(
                    <Fragment>
                      {!this.state.hideButtons && (
                        <span style={{display: "flex", fontSize: 11}}>
                          {/*<Button color="primary"*/}
                          {/*        onClick={() => EventClient.emit("BRIEFCASE_ENTRY_SAVE", null)}>Save</Button>*/}
                          {/*{checkPerms(this.props.perms, RequiredPermissions.BriefcaseDelete) && (*/}
                          {/*  <Button color="danger"*/}
                          {/*          onClick={() => {*/}
                          {/*            if (confirm('Are you sure you want to delete this file?')) {*/}
                          {/*              EventClient.emit("BRIEFCASE_ENTRY_DELETE", null);*/}
                          {/*            }*/}
                          {/*          }}>Delete</Button>*/}
                          {/*)}*/}
                          <span className={"form-group-condensed"}>
                            <Label for="status">Update Intake Status</Label>
                            <Input
                              type="select"
                              id="status"
                              value={getFormFieldValue(this.state.formData['status'])}
                              onChange={(evt) => formsUpdater(evt, this.state['formData'], this, () => this.updateStatus())}
                            >
                              {TaxIntakeStatusList.map((display, value) => {
                                return <option key={value} value={value}>{display}</option>
                              })}
                            </Input>
                      </span>

                          <ReactToPrint
                            trigger={() => {
                              // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                              // to the root node of the returned component as it will be overwritten.
                              return <Button color="secondary">Print Intake</Button>;
                            }}
                            content={() => this.intakeRef}
                          />

                          <Button color="secondary"
                                  onClick={() => this.closeMe()}>Close</Button>
                        </span>
                      )}
                    </Fragment>
                  )}>
        {!this.state.dataLoaded ?
          <Fragment>Loading
            <div className="sk-three-bounce">
              <div className="sk-child sk-bounce1"></div>
              <div className="sk-child sk-bounce2"></div>
              <div className="sk-child sk-bounce3"></div>
            </div>
          </Fragment>
          :


          <Fragment>
            <Nav tabs style={{cursor: "pointer"}}>
              <NavItem>
                <NavLink
                  className={classnames({active: this.state.activeTab === '1'})}
                  onClick={() => this.toggleTab('1')}>
                  Intake
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({active: this.state.activeTab === '2'})}
                  onClick={() => this.toggleTab('2')}>
                  Notes
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={classnames({active: this.state.activeTab === '3'})}
                  onClick={() => this.toggleTab('3')}>
                  Documents
                </NavLink>
              </NavItem>
              {/*<NavItem>*/}
              {/*  <NavLink*/}
              {/*    className={classnames({active: this.state.activeTab === '6'})}*/}
              {/*    onClick={() => this.toggleTab('6')}>*/}
              {/*    Briefcase Links*/}
              {/*  </NavLink>*/}
              {/*</NavItem>*/}
            </Nav>
            <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId="1">
                <Row>
                  <Col md={6} sm={12}>

                  </Col>
                </Row>

                <div id="TaxIntakeForm" ref={el => (this.intakeRef = el)}>
                  <p>
                    To help us better serve you please tell us how you heard about our services:<br/>
                    <span id={"TaxHearAbout"}>
                      {traversePropertiesArray(this.state.formData, ['data', 'hearabout']).map((heard) => heard.value).join(", ")}
                    </span>
                  </p>
                  <table cellSpacing={0} cellPadding={0} border={0} className={"TaxIntakeTable"}>
                    <thead>
                    <tr>
                      <td colSpan={3} style={{textAlign: "center", fontWeight: "bold", display: "block"}}>
                        PRIMARY ACTIVE DUTY MILITARY MEMBER INFORMATION
                      </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td colSpan={3} style={{textAlign: "left", width: "80%"}}>
                        Rank/Name:&nbsp;
                        <span id="TaxName">
                          {[
                            traversePropertiesString(this.state.formData, ['data', 'rank']),
                            traversePropertiesString(this.state.formData, ['data', 'fname']),
                            traversePropertiesString(this.state.formData, ['data', 'lname'])
                          ].join(" ").replace(/\s\s/, "").trim()}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td className={"alignLeft thirty"}>SSN:&nbsp;<span
                        id="TaxSSN">{traversePropertiesString(this.state.formData, ['data', 'ssn'])}</span></td>
                      <td style={{textAlign: "left", width: "20%"}}>&nbsp;</td>
                      <td className={"alignLeft thirty"}>Date of Birth:&nbsp;<span
                        id="TaxBirth">{traversePropertiesString(this.state.formData, ['data', 'bdate'])}</span></td>
                    </tr>
                    <tr>
                      <td className={"alignLeft thirty"}>Mailing&nbsp;Address:&nbsp;<span
                        id="TaxAddress1">{traversePropertiesString(this.state.formData, ['data', 'address1'])}</span>
                      </td>
                      <td style={{textAlign: "left", width: "20%"}}>&nbsp;</td>
                      <td className={"alignLeft thirty"}>Apt/Box&nbsp;No.:&nbsp;<span
                        id="TaxAddress2">{traversePropertiesString(this.state.formData, ['data', 'address2'])}</span>
                      </td>
                    </tr>
                    <tr>
                      <td className={"alignLeft thirty"}>City:&nbsp;<span
                        id="TaxCity">{traversePropertiesString(this.state.formData, ['data', 'city'])}</span></td>
                      <td style={{textAlign: "left", width: "20%"}}>State:&nbsp;<span
                        id="TaxState">{traversePropertiesString(this.state.formData, ['data', 'state'])}</span></td>
                      <td className={"alignLeft thirty"}>Zip:&nbsp;<span
                        id="TaxZip">{traversePropertiesString(this.state.formData, ['data', 'zip'])}</span></td>
                    </tr>
                    <tr>
                      <td className={"alignLeft thirty"}>Cell&nbsp;Phone:&nbsp;<span
                        id="TaxCellPhone">{traversePropertiesString(this.state.formData, ['data', 'cphone'])}</span>
                      </td>
                      <td style={{textAlign: "left", width: "20%"}}>&nbsp;</td>
                      <td className={"alignLeft thirty"}>Duty&nbsp;Phone:&nbsp;<span
                        id="TaxDutyPhone">{traversePropertiesString(this.state.formData, ['data', 'dphone'])}</span>
                      </td>
                    </tr>
                    <tr>
                      <td style={{textAlign: "left", width: "50%"}} colSpan="2">Email:&nbsp;<span
                        id="TaxEmail">{traversePropertiesString(this.state.formData, ['data', 'email'])}</span>
                      </td>
                      <td style={{textAlign: "left", width: "40%"}}>&nbsp;</td>
                    </tr>
                    </tbody>
                  </table>

                  <table cellSpacing={0} cellPadding="0" border={0} className={"TaxIntakeTable"}>
                    <thead>
                    <tr>
                      <td colSpan="3" style={{textAlign: "center", fontWeight: "bold", display: "block"}}>
                        SPOUSE INFORMATION
                      </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td colSpan="3" style={{textAlign: "left", width: "80%"}}>
                        Rank/Name:&nbsp;
                        <span id="TaxSPName">
                          {[
                            traversePropertiesString(this.state.formData, ['data', 'sprank']),
                            traversePropertiesString(this.state.formData, ['data', 'spfname']),
                            traversePropertiesString(this.state.formData, ['data', 'splname'])
                          ].join(" ").replace(/\s\s/, "").trim()}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <td className={"alignLeft thirty"}>SSN:&nbsp;<span
                        id="TaxSPSSN">{traversePropertiesString(this.state.formData, ['data', 'spssn'])}</span></td>
                      <td style={{textAlign: "left", width: "20%"}}>&nbsp;</td>
                      <td className={"alignLeft thirty"}>Date of Birth:&nbsp;<span
                        id="TaxSPBirth">{traversePropertiesString(this.state.formData, ['data', 'spbdate'])}</span>
                      </td>
                    </tr>
                    <tr>
                      <td className={"alignLeft thirty"}>Cell&nbsp;Phone:&nbsp;<span
                        id="TaxSPCellPhone">{traversePropertiesString(this.state.formData, ['data', 'spcphone'])}</span>
                      </td>
                      <td style={{textAlign: "left", width: "20%"}}>&nbsp;</td>
                      <td className={"alignLeft thirty"}>Work&nbsp;Phone:&nbsp;<span
                        id="TaxSPWorkPhone">{traversePropertiesString(this.state.formData, ['data', 'spwphone'])}</span>
                      </td>
                    </tr>
                    <tr>
                      <td style={{textAlign: "left", width: "50%"}} colSpan="2">Email:&nbsp;<span
                        id="TaxSPEmail">{traversePropertiesString(this.state.formData, ['data', 'spemail'])}</span>
                      </td>
                      <td style={{textAlign: "left", width: "40%"}}>&nbsp;</td>
                    </tr>
                    </tbody>
                  </table>
                  <p>
                    What is your filing status as of <span id="TaxFilingStatusDate"></span>?&nbsp;&nbsp;&nbsp;<span
                    id="TaxFilingStatus">{traversePropertiesString(this.state.formData, ['data', 'filing_status'])}</span>
                  </p>
                  <p>
                    Is anyone else claiming you, your spouse or any of your dependents on their
                    return?&nbsp;&nbsp;&nbsp;<span
                    id="TaxClaimAnyone">{this.state.formData && this.state.formData.data && this.state.formData.data.anyone_claim ? "Yes" : "No"}</span>
                  </p>
                  <p>
                    Do you currently own a home?&nbsp;&nbsp;&nbsp;<span
                    id="TaxOwnHome">{this.state.formData && this.state.formData.data && this.state.formData.data.own_home ? `Yes - ${this.state.formData.data.home_type || "Personal Residence"}` : "No"}</span>
                  </p>
                  <table cellSpacing={0} cellPadding={0} border={0} id="TaxIntakeFormDependents">
                    <thead>
                    <tr>
                      <td colSpan="4" style={{textAlign: "center", fontWeight: "bold", display: "block"}}>DEPENDENTS
                      </td>
                    </tr>
                    <tr>
                      <td style={{textAlign: "center", width: "20%", fontWeight: "bold"}} width="20%">Name</td>
                      <td style={{textAlign: "center", width: "20%", fontWeight: "bold"}} width="20%">Date of Birth</td>
                      <td style={{textAlign: "center", width: "20%", fontWeight: "bold"}} width="20%">SSN</td>
                      <td style={{textAlign: "center", width: "20%", fontWeight: "bold"}} width="20%">Relationship</td>
                    </tr>
                    </thead>
                    <tbody>
                    {traversePropertiesArray(this.state.formData, ['data', 'dependents']).map((dep, index) => {
                      return <tr key={index}>
                        <td>{index + 1}. {traversePropertiesString(dep, ['name'])}</td>
                        <td>{traversePropertiesString(dep, ['bdate'])}</td>
                        <td>{traversePropertiesString(dep, ['ssn'])}</td>
                        <td>{traversePropertiesString(dep, ['relationship'])}</td>
                      </tr>
                    })}
                    </tbody>
                  </table>
                  <p style={{marginTop: 10}}>
                    <strong>NOTES</strong><br/>
                    <span id="TaxNotes">{traversePropertiesString(this.state.formData, ['data', 'notes'])}</span>
                  </p>
                  <p style={{fontSize: 11}}>
                    Your signature below is acknowledgement that you have read this form, the
                    information that you have provided is accurate to the best of your knowledge. Many of our tax
                    preparers are independent financial consultants and licensed insurance agents. Based on your
                    financial condition a solicitation for the sale of life insurance, annuities, and/or Individual
                    Retirement Arrangements (IRA's) may be made. You further understand and acknowledge that if your
                    tax return is adjusted by the IRS or State because of omission of information or a data entry
                    error YOU will be responsible for paying the correct tax and/or receiving the correct credits or
                    payments once properly adjusted by the IRS or State. However, AFBN will pay any corresponding
                    interest and penalties up until the due date, on the first correspondence notice sent by the IRS
                    and/or State. Any additional taxes, interest, and penalties owed after the initial due date are
                    your sole and separate responsibility. This office is under video and or audio surveillance for
                    your protection, quality and training purposes, you acknowledge and grant authorization for that
                    purpose. AFBN is not affiliated or endorsed by the Department of Defense or United States
                    Government.
                  </p>
                  <table cellSpacing={0} cellPadding={0} border={0} id="TaxIntakeSignature">
                    <tbody>
                    <tr>
                      <td className={"alignLeft thirty"}><span
                        id="TaxSignature">{traversePropertiesString(this.state.formData, ['data', 'signature'])}</span>
                      </td>
                      <td className={"alignLeft five inlineBlock"}>&nbsp;</td>
                      <td className={"alignLeft thirty"}><span
                        id="TaxSignatureDate">{traversePropertiesString(this.state.formData, ['data', 'datesigned'])}</span>
                      </td>
                    </tr>
                    <tr>
                      <td className={"alignLeft thirty inlineBlock"}>Signature</td>
                      <td className={"alignLeft five inlineBlock"}>&nbsp;</td>
                      <td className={"alignLeft thirty inlineBlock"}>Date</td>
                    </tr>
                    <tr>
                      <td className={"alignLeft thirty"}>&nbsp;</td>
                      <td className={"alignLeft five inlineBlock"}>&nbsp;</td>
                      <td className={"alignLeft thirty"}>&nbsp;</td>
                    </tr>
                    <tr>
                      <td className={"alignLeft thirty"}><span
                        id="TaxSignature2">{traversePropertiesString(this.state.formData, ['data', 'spsignature'])}</span>
                      </td>
                      <td className={"alignLeft five inlineBlock"}>&nbsp;</td>
                      <td className={"alignLeft thirty"}><span
                        id="TaxSignatureDate2">{traversePropertiesString(this.state.formData, ['data', 'spdatesigned'])}</span>
                      </td>
                    </tr>
                    <tr>
                      <td className={"alignLeft thirty inlineBlock"}>Signature</td>
                      <td className={"alignLeft five inlineBlock"}>&nbsp;</td>
                      <td className={"alignLeft thirty inlineBlock"}>Date</td>
                    </tr>
                    </tbody>
                  </table>
                </div>

              </TabPane>
              <TabPane tabId="2">
                <NotesTab notes={this.state.notes}
                          lmsId={this.state.lmsId}
                          onAddMode={(mode) => this.setState({hideButtons: mode})}
                          onUpdate={(notes) => this.setState({notes})}
                />
              </TabPane>
              <TabPane tabId="3">
                <DocumentsTab documents={this.state.documents}
                              lmsId={this.state.lmsId}
                              onUpdate={(documents) => this.setState({documents})}
                />
              </TabPane>
            </TabContent>
          </Fragment>
        }
      </MakeDialog>
    )
  }

  showAttachLMSPicker() {
    this.setState({showLMSPicker: true});
  }

  attachLMSEntry(lead) {
    const obj = {
      attachedLeads: lead,
    }
    formsMultiUpdater(obj, this.state['formData'], this, () => {
      this.setState({showLMSPicker: false})
    });
  }
}
/*
{!!file_id && (
<MakeDialog isOpen={!!file_id} header="Briefcase File">
<LMSEntryEditor
eventName="LMSEntryEditor"
saveEvent="LMS_ENTRY_SAVE"
deleteEvent="LMS_ENTRY_DELETE"
// addSelection={this.state.addSelection}
folderId={folder_id}
onSave={() => {
this.handleFolderClick(folder_id);
EventClient.emit("BRIEFCASE_REFRESH", folder_id);
}}
token={this.props.token}
onClose={() => {
this.handleFolderClick(folder_id);
}}
edit={extractNumber(file_id)}
footer={(
<Fragment>
<Button color="primary"
onClick={() => EventClient.emit("BRIEFCASE_ENTRY_SAVE", null)}>Save</Button>
{checkPerms(this.props.perms, RequiredPermissions.BriefcaseDelete) && (
<Button color="danger"
onClick={() => {
if (confirm('Are you sure you want to delete this file?')) {
EventClient.emit("BRIEFCASE_ENTRY_DELETE", null);
}
}}>Delete</Button>
)}
<Button color="secondary"
onClick={() => this.handleFolderClick(folder_id)}>Close</Button>
</Fragment>
)}/>
</MakeDialog>
)}
*/


// WEBPACK FOOTER //
// ./src/containers/Leads/modals/TaxIntakeEditor.js